// extracted by mini-css-extract-plugin
export default {"root":"_346AAtaK","rootInner":"_3_Ifn9LN"};